const initNewsTabs = () => {
    const newsTabsSections = document.querySelectorAll(".news-tabs");

    newsTabsSections.forEach((section) => {
        const navigation = section.querySelector(".news-tabs__navigation");
        const tabs = section.querySelectorAll(".news-tabs__tab");
        const panels = section.querySelectorAll(".news-tabs__panel");

        if (!tabs.length || !panels.length || !navigation) return;

        // Create sliding indicator
        const indicator = document.createElement("span");
        indicator.className = "news-tabs__indicator";
        navigation.appendChild(indicator);

        const updateIndicator = (activeTab) => {
            const tabRect = activeTab.getBoundingClientRect();
            const navRect = navigation.getBoundingClientRect();
            const padding = 2; // Match the padding from CSS
            const left = tabRect.left - navRect.left - padding;
            const width = tabRect.width;

            indicator.style.width = `${width}px`;
            indicator.style.transform = `translateX(${left}px)`;
        };

        const handleTabClick = (clickedTab) => {
            const targetTab = clickedTab.dataset.tab;

            // Update tabs
            tabs.forEach((tab) => {
                const isActive = tab === clickedTab;
                tab.classList.toggle("news-tabs__tab--active", isActive);
                tab.setAttribute("aria-selected", isActive.toString());
            });

            // Update indicator position
            updateIndicator(clickedTab);

            // Update panels
            panels.forEach((panel) => {
                const isActive = panel.dataset.panel === targetTab;
                panel.classList.toggle("news-tabs__panel--active", isActive);

                if (isActive) {
                    panel.setAttribute("aria-hidden", "false");
                } else {
                    panel.setAttribute("aria-hidden", "true");
                }
            });
        };

        // Initialize indicator position
        const activeTab = Array.from(tabs).find((tab) =>
            tab.classList.contains("news-tabs__tab--active")
        );
        if (activeTab) {
            // Use requestAnimationFrame to ensure layout is ready
            requestAnimationFrame(() => {
                updateIndicator(activeTab);
            });
        }

        // Initialize aria-hidden attributes
        panels.forEach((panel) => {
            const isActive = panel.classList.contains("news-tabs__panel--active");
            panel.setAttribute("aria-hidden", (!isActive).toString());
        });

        // Handle window resize to reposition indicator
        let resizeTimeout;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                const currentActiveTab = Array.from(tabs).find((tab) =>
                    tab.classList.contains("news-tabs__tab--active")
                );
                if (currentActiveTab) {
                    updateIndicator(currentActiveTab);
                }
            }, 100);
        });

        // Add click handlers
        tabs.forEach((tab) => {
            tab.addEventListener("click", () => handleTabClick(tab));

            // Keyboard navigation
            tab.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleTabClick(tab);
                } else if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
                    e.preventDefault();
                    const currentIndex = Array.from(tabs).indexOf(tab);
                    const direction = e.key === "ArrowLeft" ? -1 : 1;
                    const nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
                    tabs[nextIndex].focus();
                    handleTabClick(tabs[nextIndex]);
                }
            });
        });
    });
};

document.addEventListener("DOMContentLoaded", initNewsTabs);
